import DownloadFiles from 'components/pages/request/files/download'
export default DownloadFiles
